import { render, staticRenderFns } from "./CustomerTables.vue?vue&type=template&id=e224f682&scoped=true&"
import script from "./CustomerTables.vue?vue&type=script&lang=js&"
export * from "./CustomerTables.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTables.vue?vue&type=style&index=0&id=e224f682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e224f682",
  null
  
)

export default component.exports